import React from 'react';
import { FaEye, FaFileAlt, FaHeart, FaEnvelope } from 'react-icons/fa';
import './PropertyStatsDisplay.css';

const PropertyStatsDisplay = ({ stats }) => {
  if (!stats) {
    return null;
  }

  return (
    <div className="property-stats-display">
      <div className="stat-item">
        <FaEye className="stat-icon" />
        <span className="stat-value">{stats.viewCount || 0}</span>
        <span className="stat-label">Views</span>
      </div>
      <div className="stat-item">
        <FaFileAlt className="stat-icon" />
        <span className="stat-value">{stats.reportCount || 0}</span>
        <span className="stat-label">Reports</span>
      </div>
      <div className="stat-item">
        <FaHeart className="stat-icon" />
        <span className="stat-value">{stats.saveCount || 0}</span>
        <span className="stat-label">Saves</span>
      </div>
      <div className="stat-item">
        <FaEnvelope className="stat-icon" />
        <span className="stat-value">{stats.inquiryCount || 0}</span>
        <span className="stat-label">Inquiries</span>
      </div>
    </div>
  );
};

export default PropertyStatsDisplay;
